export class PackageOptionsListObj {
    constructor() {
        this.independentOptions = []; // 套餐
        this.subindependentOptions = []; // 子套餐
        this.addonOptions = []; // 升级套餐
        this.anonymousOptions = []; // 匿名套餐
        this.openApiOptions = []; // OpenAPI套餐
        this.showIndependentOptions = false;
        this.showSubindependentOptions = false;
        this.showAddonOptions = false;
        this.showAnonymousOptions = false;
    }
}
export class HistoryPackageOptionsListObj {
    constructor() {
        this.historyIndependentOptions = []; // 历史套餐
        this.historySubindependentOptions = []; // 历史子套餐
        this.historyAddonOptions = []; // 升级套餐
        this.showHistoryIndependentOptions = false;
        this.showHistorySubindependentOptions = false;
        this.showHistoryAddonOptions = false;
    }
}
export class PackageAllSelectData {
    constructor() {
        this.currentSelectPackages = [];
        this.hasHistoryPackage = false;
        this.isAnonymousPrivliege = false;
    }
}
export class AllPackageOptionsListData {
    constructor() {
        this.allCurrentOptionsData = new PackageOptionsListObj();
        this.allHistoryOptionsData = new HistoryPackageOptionsListObj();
    }
}
